import React from "react";

const BellIcon = ({ width, height, color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 34 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="17"
        cy="17.5"
        rx="17"
        ry="17.5"
        fill="#00008B"
        fillOpacity="0.07"
      />
      <path
        d="M24.4999 23.625V24.5H9.49992V23.625L11.1666 21.875V16.625C11.1666 13.9125 12.8583 11.5238 15.3333 10.7537C15.3333 10.6662 15.3333 10.5875 15.3333 10.5C15.3333 10.0359 15.5088 9.59075 15.8214 9.26256C16.134 8.93437 16.5579 8.75 16.9999 8.75C17.4419 8.75 17.8659 8.93437 18.1784 9.26256C18.491 9.59075 18.6666 10.0359 18.6666 10.5C18.6666 10.5875 18.6666 10.6662 18.6666 10.7537C21.1416 11.5238 22.8333 13.9125 22.8333 16.625V21.875L24.4999 23.625ZM18.6666 25.375C18.6666 25.8391 18.491 26.2842 18.1784 26.6124C17.8659 26.9406 17.4419 27.125 16.9999 27.125C16.5579 27.125 16.134 26.9406 15.8214 26.6124C15.5088 26.2842 15.3333 25.8391 15.3333 25.375H18.6666ZM23.4583 9.79125L22.2749 11.0338C23.6999 12.5125 24.4999 14.525 24.4999 16.625H26.1666C26.1666 14.0612 25.1999 11.5938 23.4583 9.79125ZM7.83325 16.625H9.49992C9.49992 14.525 10.2999 12.5125 11.7249 11.0338L10.5416 9.79125C8.79992 11.5938 7.83325 14.0612 7.83325 16.625Z"
        fill="#00008B"
      />
    </svg>
  );
};

export default BellIcon;
